import { render, staticRenderFns } from "./PopupTerms.vue?vue&type=template&id=471f72a7&scoped=true&"
import script from "./PopupTerms.vue?vue&type=script&lang=js&"
export * from "./PopupTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471f72a7",
  null
  
)

export default component.exports